import type { CalendarType } from '../Calendar.types'
import { getTimeFromDate } from './getTimeFromDate'

export const getInitialSelectedTimes = (selectedDates: Date[], calendarType: CalendarType) => {
  if (!selectedDates.length && calendarType === 'single') {
    return [getTimeFromDate(new Date())]
  }

  if (!selectedDates.length && calendarType === 'range') {
    return [getTimeFromDate(new Date()), getTimeFromDate(new Date())]
  }

  return selectedDates.map(getTimeFromDate)
}
